export const MODULE_NAME = 'cms';
